<template>
  <div class="card card-2">
    <div class="card-heading">
      <div class="account-erstellen2">
        {{ $t("reset_password") }}
        <br />
        {{ $t("zurücksetzen") }}
      </div>
      <div class="registration-detail2">{{ $t("reset_password_email") }}</div>
      <div class="img-box3">
        <img src="@/assets/images/Logo.png" class="img-responsive" alt="img" />
      </div>
    </div>
    <div class="card-body card-body3">
      <form @submit.prevent="loginFrom()" enctype="multipart/form-data" class="form-border-none">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label>{{ $t("email") }} {{ $t("address") }}*</label>
            <div class="input-group">
              <input
                v-model="email"
                @blur="$v.email.$touch()"
                :class="{ 'is-invalid': submitted && $v.email.$error }"
                class="input--style-2 form-control"
                type="email"
                placeholder="Max.mustermann@web.de"
              />
            </div>
            <div class="alert alert-danger alert-dismissible" v-if="error">
              <button type="button" class="close" data-dismiss="alert">&times;</button>
              {{error}}
            </div>
            <div :class="{ 'boxdiv': submitted && $v.token.$error }">
              <vue-recaptcha
                @verify="markRecaptchaAsVerified"
                sitekey="6Le-wvkSAAAAAPBMRTvw0Q4Muexq9bi0DJwx_mJ-"
              ></vue-recaptcha>
            </div>
          </div>
        </div>

        <div class="p-t-30 btn-down2">
          <button class="btn btn--radius btn--green" type="submit">{{ $t("reset") }}</button>
          <span class="al-login">
            {{ $t("or") }}
            <a href="/login">{{ $t("login") }}</a>
          </span>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
import { required, email, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'login',
  data () {
    return {
      error: '',
      msg: '',
      email: '',
      token: '',
      submitted: '',
      check: false
    }
  },
  validations: {
    token: { required },
    email: { required, email }
  },
  components: { VueRecaptcha },
  methods: {
    markRecaptchaAsVerified (response) {
      this.token = response
    },
    loginFrom () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      axios.post(`https://dev2019.projectdocu.net/projects/token.php`,
          {
            email: this.email,
            // captchatoken: this.token
          }).then(response => {
          this.token = ''
          if (response.status == 200) {
            this.$router.push('/ForgotMs')
          } else {
            this.error = 'please try again.'
          }
        })
        .catch(e => {
          console.log(e.response.status)
          console.log(e.response.data.status)

          this.error = e.response.data.status
        })
    }
  },
  computed: {
    isDisabled: function () {
      return this.check
    }
  },
  created () {}
}
</script>
<style scoped >
</style>



// WEBPACK FOOTER //
// src/components/login/Forgot.vue